import "./Sitemap.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SitemapIntro from "./sections/SitemapIntro";
import Hierarchy from "./sections/Hierarchy";
import Footer from "@/reusable_sections/Footer";
export default function SitemapPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="Sitemap" />
      <SitemapIntro />
      <Hierarchy />
      <Footer />
    </div>;
}